import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/proexpert/dashboard')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/proexpert/dashboard"!</div>
}
